import * as React from "react"
import DocsVersion from "./docs-version"

export default {
  title: "Documentation",
  rootPath: "/docs/",
  searchType: "docs",
  links: [
    {
      name: "Tutorials",
      to: "/docs/tutorial/",
    },
    {
      name: "How-To Guides",
      to: "/docs/how-to/",
    },
    {
      name: "Reference",
      to: "/docs/reference/",
    },
    {
      name: "Concepts",
      to: "/docs/conceptual/",
    },
  ],
  rightElement: <DocsVersion />,
}
